var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41247 11.9C1.0627 11.9 0.712673 11.7709 0.439193 11.5113C-0.126099 10.9738 -0.148641 10.0795 0.388658 9.51399L3.54904 6.19011L0.391879 2.88928C-0.147402 2.32572 -0.127585 1.43146 0.43622 0.891932C1.00027 0.352403 1.89428 0.372468 2.43357 0.936273L6.52214 5.21014C7.04334 5.75512 7.04433 6.61346 6.52536 7.16018L2.43703 11.4608C2.15885 11.7524 1.78653 11.9 1.41247 11.9Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrow_next.f327ea4f0bfd1214560a402b9df24c16.svg";
export { ForwardRef as ReactComponent };